var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-flag-7",
    d: "M4,24H2V0H4ZM22,2H6V14H22L18,8.031Z",
    transform: "translate(-2)",
    fill: "#00ded5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityFlag);
export default __webpack_public_path__ + "static/media/priority-flag.4ee233653a4803adce308d584d981d14.svg";
export { ForwardRef as ReactComponent };